module.exports = __webpack_public_path__ + "static/img/Thomas-Burgess.59d551c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas-Burgess.jpg
// module id = iuL1
// module chunks = 0